let unreadFolders = {}

const updateUnread = (group_id, tyle_folders, type) => {
    if (unreadFolders[group_id]) {
        if (type === 'delete') {
            delete unreadFolders[group_id]
        } else {
            unreadFolders[group_id] = tyle_folders
        }
    }
}

const initUnread = (group_id, tyle_folders) => {
    unreadFolders[group_id] = tyle_folders
}

const resetUnread = () => {
    var props = Object.getOwnPropertyNames(unreadFolders);
    for (var i = 0; i < props.length; i++) {
        delete unreadFolders[props[i]];
    }
}

const workerUnread = {
    updateUnread,
    initUnread,
    resetUnread,
    unreadFolders
}

module.exports = workerUnread